module.exports = __webpack_public_path__ + "img/product-core-2.ea2bc458.png";